<script setup lang="ts">
import { usePopupManager } from "@/shared/composables/usePopupManager";

// ui
import Button from "@/shared/components/button/Button.vue";

import type { AlertUnExpectedErrorPopupProps } from "@/shared/plugins/interface";

const props = defineProps<AlertUnExpectedErrorPopupProps>();

const { closePopup } = usePopupManager();

const clickConfirmButton = () => {
    closePopup(props.closeKey);
};
</script>

<template>
    <section class="flex flex-col items-center justify-center size-full">
        <div
            class="mb-[3.2rem] flex h-auto w-full flex-col items-center justify-center gap-[0.8rem]"
        >
            <p className="font-pretended text-base font-semibold text-primary-red">알림</p>
            <h2 class="font-semibold text-center whitespace-pre-wrap text-md text-primary-black">
                {{ rest.title }}
            </h2>
            <div class="w-full h-auto max-h-[20rem] overflow-auto mb-[3.2rem]">
                <p class="text-base font-normal text-center whitespace-pre-wrap text-primary-gray">
                    {{ rest.message }}
                </p>
            </div>
        </div>
        <div
            class="flex h-auto w-full min-w-[30rem] flex-col items-center justify-center gap-[1.2rem]"
        >
            <Button
                :type="'button'"
                :color="'primary'"
                :value="'확인'"
                :disabled="false"
                :is-width-full="true"
                @click="clickConfirmButton"
            />
        </div>
    </section>
</template>

<style lang="scss" scoped></style>
